import { cva, type VariantProps } from 'class-variance-authority';
import * as React from 'react';

import { cn } from '@/utils/classUtils';
import { COLORS } from '@ditto/shared';

const badgeVariants = cva(
  'inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    variants: {
      variant: {
        default: 'border-transparent bg-primary text-primary-foreground shadow',
        secondary: 'border-transparent bg-secondary text-secondary-foreground',
        destructive:
          'border-transparent bg-destructive text-destructive-foreground shadow',
        outline: 'text-foreground',
      },
      color: {
        yellow: 'bg-yellow-200 hover:bg-yellow-200',
        blue: 'bg-blue-200 hover:bg-blue-200',
        magenta: 'bg-magenta-200 hover:bg-magenta-200',
        green: 'bg-green-200 hover:bg-green-200',
        purple: 'bg-purple-200 hover:bg-purple-200',
        orange: 'bg-orange-200 hover:bg-orange-200',
        red: 'bg-red-200 hover:bg-red-200',
        tan: 'bg-tan-200 hover:bg-tan-200',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {
  color?: (typeof COLORS)[number];
}

function Badge({ className, variant, color, ...props }: BadgeProps) {
  return (
    <div
      className={cn(badgeVariants({ variant, color }), className)}
      {...props}
    />
  );
}

export { Badge, badgeVariants };
